import { render, staticRenderFns } from "./Direccion.vue?vue&type=template&id=047c5bca"
import script from "./Direccion.vue?vue&type=script&lang=js"
export * from "./Direccion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports